import React, { Component } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {Footer, SideNav, TopBar} from '../partials/layouts.js';
import { LogoutModal } from './logout.js';
import {postData, updateData, deleteItem} from './constants.js';
const moment = require('moment');

class FeeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data          :[],
      isLoading     :true,
      show          :false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addFee = this.addFee.bind(this);
    this.editFee = this.editFee.bind(this);
    this.deleteFee = this.deleteFee.bind(this);
  }

  async getFees() {
    try {
      const response = await fetch('/api/fees');
      const json = await response.json();
      this.setState({ data: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getFees();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const data = this.state;
    this.setState({ show: false, isLoading: true });
    delete data.data;
    delete data.isLoading;
    if(data.id){
      updateData('/api/fee/'+data.id, data)
        .then((response) => {
          console.log(response);
          this.getFees();
      });
    }else{
      postData('/api/fee', data)
        .then((response) => {
          console.log(response);
          this.getFees();
      });
    }
  }

  addFee() {
    this.setState({
      id            :"",
      name          :"",
      price         :"",
      active_period :"",
      status        :"1",
      show: true
    });
  }

  editFee(e) {
    const id = parseInt(e.target.id);
    const fees = this.state.data;
    const selectedFee = fees.filter(e=> e.id === id)[0];
    this.setState(selectedFee);
    this.setState({ show: true });
  }

  deleteFee(e) {
    const id = parseInt(e.target.id);
    deleteItem("/api/fee/"+id)
    .then((response) => {
      console.log(response);
      this.getFees();
    });
  }

  render() {
    if(!this.state.isLoading){
      const fees = this.state.data;
      const fee_list = fees.map((fee)=>
          <tr key={fee.id} id={fee.id}>
            <td>{fee.name}</td>
            <td>$ {fee.price}</td>
            <td>{fee.status?"Active":"Inactive"}</td>
            <td>
              <div className="row">
                <div className="col">
                  <Link to={'/fee-details/'+fee.id}> <i id={fee.id} className="fas fa-info-circle text-primary action-icons" onClick={this.editFee}></i></Link>
                </div>
                <div className="col">
                  <i id={fee.id} className="fas fa-pencil-alt text-warning action-icons" onClick={this.editFee}></i>
                </div>
                <div className="col">
                  <i id={fee.id} className="fas fa-trash-alt text-danger action-icons" onClick={this.deleteFee}></i>
                </div>
              </div>
            </td>
          </tr>
      );
      return(
          <>
          <div className="row">
              <div className="col-lg-8">
                  <div className="card shadow mb-2">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-light">Fees</h4>
                      </div>
                      <div className="card-body">
                          <div className="table-responsive fee-table">
                              <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                  <thead>
                                      <tr>
                                          <th>Name</th>
                                          <th>Fees</th>
                                          <th>Status</th>
                                          <th></th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      {fee_list}
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
                  <button className="btn btn-primary" onClick={this.addFee}><i className="fas fa-plus"></i> New Fee</button>
              </div>
              <div className="col-lg-4">
                {this.state.show?(
                  <div className="card shadow mb-4">
                      <div className="card-header py-3">
                          <h4 className="m-0 font-weight-bold text-light">Add / Edit Fee</h4>
                      </div>
                      <div className="card-body">
                          <form className="user" onSubmit={this.handleSubmit} autoComplete="off">
                              <div className="form-group">
                                  <label>Name</label>
                                  <input type="text" name="name" className="form-control" value={this.state.name} onChange={this.handleInputChange} required />
                              </div>
                              <div className="form-group">
                                  <label>Fees</label>
                                  <input type="number" name="price" className="form-control" value={this.state.price} onChange={this.handleInputChange} required />
                              </div>
                              <div className="form-group">
                                  <label>Active Period</label>
                                  <div className='input-group'>
                                    <input type="date" name="start_date" className="form-control" value={this.state.start_date} onChange={this.handleInputChange} required />
                                    <input type="date" name="end_date" className="form-control" value={this.state.end_date} onChange={this.handleInputChange} required />
                                  </div>
                              </div>
                              <div className="form-group">
                                  <label>Status</label>
                                  <select name="status" className="form-select" value={this.state.status} onChange={this.handleInputChange}>
                                      <option value="0">InActive</option>
                                      <option value="1">Active</option>
                                  </select>
                              </div>
                              <div className="form-group">
                                <input type="submit" id="fee-submit" className="btn btn-bg-success" value="Submit" />
                                <button type="button" name="cancel" className="btn btn-danger float-right" onClick={()=> this.setState({show:false})}>Cancel</button>
                              </div>
                          </form>
                      </div>
                  </div>
                ):(
                  <> </>
                )}
              </div>
          </div>
          </>
      );
    }
  }
}

class FeeDetailList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading : true,
      showPayment: false,
      selectedResidentFeeId: null,
      statusFilter    : "all", // all, paid, notPaid
      filter: '',
      data: [],
      filteredRows: [],
      transaction_id: '',
      transaction_date: moment().format(moment.HTML5_FMT.DATE),
      fee: {},
      receipt : {},
    };
    this.sendRemainder = this.sendRemainder.bind(this);
  }

  handleStatusFilterChange = (e) => {
    
    const filter = e.target.value;
    this.setState({statusFilter: filter});
  }

  handleFilterChange = (e) => {
    this.setState({filter: e.target.value});
  }
  
  handleFilter = () => {
    const data = this.state.data;
    const filter = this.state.filter;

    var _filteredRows = this.state.statusFilter === 'all'
      ? data.sort((a, b) => b.is_paid - a.is_paid)
      : data.filter(r => (this.state.statusFilter === 'paid' ? r.is_paid : !r.is_paid));
    
    if(filter === ''){
      this.setState({filteredRows: _filteredRows});
    }else{
      _filteredRows = _filteredRows.filter(r => {
        // handle null values and check if the filter exists in the row
        if (r.lot_no === undefined) r.lot_no = '';
        if (r.owner_name === undefined) r.owner_name = '';
        if (r.wo_street_address === undefined) r.wo_street_address = '';
        
        return r.lot_no.toLowerCase().includes(filter.toLowerCase()) || 
               r.owner_name.toLowerCase().includes(filter.toLowerCase()) ||
               r.wo_street_address.toLowerCase().includes(filter.toLowerCase())
      });
      this.setState({filteredRows: _filteredRows});
    }
  }

  showFeePayment = (id) => {

    const data = this.state.data;
    const fee = data.filter(a=> a.id === parseInt(id))[0];

    if(id){
      this.setState({showPayment: true, selectedResidentFeeId: id, fee: fee});
    }else{
      this.setState({showPayment: false, selectedResidentFeeId: null, fee: {}});
    }
  }

  showFeeReceipt = (id) => {
    if(id){
      const data = this.state.data;
      const receipt = data.filter(a=> a.id === parseInt(id))[0];
      
      console.log('receipt', receipt);

      this.setState({showReceipt: true, selectedResidentFeeId: id, receipt: receipt});
    }else{
      this.setState({showReceipt: false, selectedResidentFeeId: null, receipt: {}});
    }
  }

  saveFees = () => {
    // api call to save fees
    var data = {
      id: this.state.selectedResidentFeeId,
      transaction_id: this.state.transaction_id,
      transaction_date: this.state.transaction_date,
      notes: this.state.notes
    };
    
    updateData('/api/fee_payment/'+this.state.selectedResidentFeeId, data)
      .then((response) => {
        console.log(response);
        this.getFeeDetails();
        this.setState({statusFilter: '', filter: '', showPayment: false, selectedResidentFeeId: null, transaction_id: '', transaction_date: moment().format(moment.HTML5_FMT.DATE), notes: ''});
        // refresh the list
    });
  }  

  sendRemainder(e) {
    var buttons = document.getElementsByClassName("remainderBtn");
    console.log(buttons);
    for(const item of buttons) {
      item.disabled=true;
    }
    const fee_details = this.state.data;
    const data = fee_details.filter(a=> a.id === parseInt(e.target.id))[0];
    console.log(data);

    updateData('/api/plan-expiry-remainder', data)
      .then((response) => {
        console.log(response);
        for(const item of buttons) {
          item.disabled=false;
        }
        this.getFeeDetails();
    });
  }

  async getFeeDetails() {
    try {
      const response = await fetch('/api/fee_details/'+this.props.feeId);
      var json = await response.json();
      json = json.sort((a, b) => b.is_paid - a.is_paid)
      this.setState({ data: json, filteredRows: json });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.getFeeDetails();
  }

  render() {
    if(!this.state.isLoading){

      if(this.state.showPayment){
        // show input fields for payment; Invoice number, date. show button to save or cancel
        return (
          <>
            <div className="card shadow mb-2">
              <div className="card-header py-3">
                  <h4 className="m-0 font-weight-bold text-light">Fee Payment</h4>
              </div>
              <div className="card-body">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td>Fee name</td>
                      <td>{this.state.fee.fee_name}</td>
                    </tr>
                    <tr>
                      <td>Owner name</td>
                      <td>{this.state.fee.owner_name}</td>
                    </tr>
                    <tr>
                    <td>W.O. Property Address</td>
                      <td>{this.state.fee.wo_street_address}</td>
                    </tr>
                  </tbody>
                </table>
                <div className="row g-0">
                  <div className="col-md-6">
                    <label htmlFor="invoiceNumfocus on invoice numberber">Invoice Number</label>
                    <input type="text" className="form-control" autoFocus
                    onChange={(e)=>this.setState({transaction_id: e.target.value})}
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="invoiceDate">Date</label>
                    <input type="date" 
                    className="form-control" 
                    onChange={(e)=>this.setState({transaction_date: e.target.value})}
                    value={this.state.transaction_date} />
                  </div>
                </div>
                <div className="row g-0">
                  <div className="col-md-12">
                    <label htmlFor="notes">Notes</label>
                    <textarea className="form-control" id="notes" rows="3" 
                    onChange={(e)=>this.setState({notes: e.target.value})}
                    ></textarea>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-12">
                    <button type="button" className="btn btn-success float-right" onClick={this.saveFees}>Save</button>
                    <button type="button" className="btn btn-danger float-right mr-2" onClick={() => this.showFeePayment(null)}> Cancel </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }else{
        if(this.state.showReceipt){
          // show receipts for the selected fee: transaction id, date, notes, close button. not editable
          return (
            <div className="card shadow mb-2">
              <div className="card-header py-3">
                <h4 className="m-0 font-weight-bold text-light">Fee Receipt</h4>
              </div>
              <div className="card-body">
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td>Fee name</td>
                      <td>{this.state.receipt.fee_name}</td>
                    </tr>
                    <tr>
                      <td>Owner name</td>
                      <td>{this.state.receipt.owner_name}</td>
                    </tr>
                    <tr>
                      <td>W.O. Property Address</td>
                      <td>{this.state.receipt.wo_street_address}</td>
                    </tr>
                    <tr>
                      <td>{this.state.receipt.payment_mode === 'online' ? 'Transaction Reference' : 'Invoice Number' }</td>
                      <td>{this.state.receipt.transaction_id}</td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td>{moment(this.state.receipt.transaction_date).format("LL")}</td>
                    </tr>
                    {this.state.receipt.payment_mode === 'offline' &&
                      (
                        <tr>
                          <td>Notes</td>
                          <td>{this.state.receipt.notes}</td>
                        </tr>
                      )
                    }
                    <tr>
                      <td>Payment mode</td>
                      <td>{this.state.receipt.payment_mode}</td>
                    </tr>
                  </tbody>
                </table>
                <button type="button" className="btn btn-danger float-right" onClick={() => this.showFeeReceipt(null)}> Close </button>
              </div>
            </div>
          )
        }else{
          const resident_fee_list = this.state.filteredRows.map((r)=>
              <tr key={r.id} id={r.id}>
                <td>{r.lot_no}</td>
                <td>{r.owner_name}</td>
                <td>{r.wo_street_address}</td>
                <td className={r.is_paid?"text-nowrap text-success fw-bold":"text-nowrap text-danger fw-bold"}>{r.is_paid?"Paid":"Not paid"}</td>
                {/* <td>{r.last_remainder?moment(r.last_remainder).format("LLL"):""}</td> */}
                {/* <td className="text-center">
                  {!r.is_paid &&
                    <button id={r.id} className="btn btn-sm btn-primary remainderBtn" onClick={this.sendRemainder}>Send Remainder</button>
                  }
                </td> */}
                <td>
                  {
                    r.is_paid ? (
                      <i className="fas fa-info-circle text-primary action-icons"
                        onClick={()=>this.showFeeReceipt(r.id)}
                      ></i>
                    ) : (
                      <i className="fas fa-pencil-alt text-warning action-icons"
                        onClick={()=>this.showFeePayment(r.id)}
                      ></i>
                    )
                  }
                </td>
              </tr>
          );
    
          return(
            <>
              <div className="card shadow mb-2">
                <div className="card-header py-3">
                    <h4 className="m-0 font-weight-bold text-light">{this.state.data[0].fee_name}</h4>
                </div>
                <div className="card-body">
    
                  <div className='row g-0'>
    
                    <div className='col-md-2'>
                      <label htmlFor='paymentStatus'>Status</label>
                      <select id='paymentStatus' className='form-control'  value={this.state.statusFilter} onChange={this.handleStatusFilterChange}>
                        <option value="all">All</option>
                        <option value="paid">Paid</option>
                        <option value="notPaid">Not Paid</option>
                      </select>                  
                    </div>
    
                    <div className='col-md-10'>
                      <label htmlFor='filter'>Filter</label>
                      {/* input group */}
                      <div className="input-group">
                        <input id='Filter' type='search' className='form-control' 
                        onChange={this.handleFilterChange}
                        placeholder='filter by lot number, owner name, property address' />
                        <button className="btn btn-sm btn-primary" 
                          onClick={this.handleFilter}>Filter</button>
                      </div>
                    </div>
                  </div>
    
                  <div className="table table-responsive fee-table mt-3">
                      <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                          <thead>
                              <tr>
                                  <th>Lot No.</th>
                                  <th>Owner Name</th>
                                  <th>W.O. Property Address</th>
                                  <th>Fee</th>
                                  {/* <th>Last Remainder Sent</th>
                                  <th className="text-center">Email</th> */}
                                  <th></th>
                              </tr>
                          </thead>
                          <tbody>
                              {resident_fee_list}
                          </tbody>
                      </table>
                  </div>
                </div>
              </div>
              <button type="button" className="btn btn-danger float-right" onClick={() => this.props.navigate(-1)}> Close </button>
            </>
          )
        }
      }
    }
  }

}

function FeeDetails() {
  let { feeId } = useParams();
  const navigate = useNavigate();
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <FeeDetailList feeId={feeId} navigate={navigate} />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

function Fees() {
  return (
    <>
        <div id="wrapper">
            <SideNav />
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <TopBar />
                    <div className="container-fluid">
                        <FeeList />
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
            <i className="fas fa-angle-up"></i>
        </a>
        <LogoutModal />
    </>
  );
}

export { Fees, FeeDetails };
